import React from 'react'
import { Dropdown } from 'react-bootstrap'
import type { PivotAggregationEnum } from '@ztechapps/common.contract'
import type { PivotField } from '@ztechapps/common.contract'
import { LinkDropdownToggle } from '@ztechapps/webui.data-tools'
import { listPivotAggregationOptions } from '../pivot/pivotAggregation.utils'

/** Props for the Σ aggregation menu of a pivot field. */
export type PivotAggregationDropdownProps = {
  field?: PivotField
  label: string
  aggregation: PivotAggregationEnum
  onSelect: (aggregation: PivotAggregationEnum) => void
}

/** Σ menu listing the aggregations a field offers, marking the current one. */
export const PivotAggregationDropdown = ({ field, label, aggregation, onSelect }: PivotAggregationDropdownProps) => (
  // static, so the menu's containing block is the `.modal-body` and a scroll box does not clip it — the enclosing
  // row must be `position-static` too (FieldZone.tsx, PivotCalculatedValueModal.tsx)
  <Dropdown className="position-static">
    <Dropdown.Toggle as={LinkDropdownToggle} bsStyle="secondary" aria-label={`Aggregation of ${label}`}>
      <span aria-hidden="true">Σ</span>
    </Dropdown.Toggle>
    <Dropdown.Menu>
      {listPivotAggregationOptions(field).map((option) => (
        <Dropdown.Item key={option.value} active={aggregation === option.value} onClick={() => onSelect(option.value)}>
          {option.label}
        </Dropdown.Item>
      ))}
    </Dropdown.Menu>
  </Dropdown>
)
